import React, { useEffect, useState } from "react";
import CommonLayout from "../CommonLayout";

import Delete_Account_Header from "../../../Assets/delete_account_header.png";
import "./index.css";

import { Button, Checkbox, notification, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { UserRespose } from "../../../redux/Reducer/userReducer";

import OTPInputComponent from "../../Common/Components/OTPModal";

import {
  deleteUser,
  deleteUserInitiate,
} from "../../../Services/AuthenticationServices/AuthenticationServices";

import {
  setAccessToken,
  setPhoneNumber,
  setRefreshToken,
  setSessionId,
  setVuaId,
} from "../../../Services/LocalStorageServices";

import { useHistory } from "react-router-dom";
import { Routes } from "../../../Utils/Constants/routes";

import {
  ArrowLeftOutlined,
  CheckCircleFilled,
  ClockCircleOutlined,
  DatabaseOutlined,
  DeleteOutlined,
  SettingOutlined,
  UserOutlined,
} from "@ant-design/icons";

import { translation } from "../../../i18n/translationConstant";
import { useFingerprintValidation } from "../../Authentication/FingerprintValidationContext";

const DeleteAccount: React.FC<{ user: UserRespose }> = ({ user }) => {
  const { t } = useTranslation();

  const [isOTPModalVisible, setIsOTPModalVisible] = useState(false);
  const [OTPId, setOTPId] = useState("");
  const [understood, setUnderstood] = useState(false);

  const history = useHistory();
  const { replace } = useHistory();

  const closeModal = () => {
    setIsOTPModalVisible(false);
  };

  const handleDeleteAccount = () => {
    if (!understood) {
      return;
    }

    deleteUserInitiate()
      .then((res) => res.data)
      .then((res) => {
        setOTPId(res);
        setIsOTPModalVisible(true);
      });
  };

  const verifyDeleteAccount = (otp: string) => {
    deleteUser({
      otpUniqueID: OTPId,
      code: otp,
    }).then(() => {
      setAccessToken("");
      setPhoneNumber("");
      setVuaId("");
      setRefreshToken("");
      setSessionId("");

      notification.success({
        message: t("Account Deleted"),
      });

      replace(Routes.login);
    });
  };

  const goBack = () => {
    history.goBack();
  };

  const { checkFingerprint } = useFingerprintValidation();

  useEffect(() => {
    checkFingerprint();
  }, [checkFingerprint]);

  const firstName = user && user.firstName ? user.firstName : "";

  return (
    <CommonLayout
      title={t(translation.lblDeleteAccount)}
      showBackButton={true}
    >
      <div className="deleteAccountPage">

        {/* =================================================
            HEADER
        ================================================= */}

        <div className="deleteAccountHeader">

          <Typography.Text className="deleteAccountSubtitle">
            {t("lblDeleteAccountPermanentWarning")}
          </Typography.Text>

          <div className="deleteAccountSecureBadge">
            <CheckCircleFilled />
            <span>{t("lblYourInformationIsSecure")}</span>
          </div>

        </div>


        {/* =================================================
            MAIN CONTENT
        ================================================= */}

        <div className="deleteAccountMain">

          {/* Illustration */}

          <div className="deleteAccountIllustrationWrap">
            <img
              src={Delete_Account_Header}
              alt={t("lblAccountDeletionIllustration")}
              className="deleteAccountImage"
            />
          </div>


          {/* Intro */}

          <div className="deleteAccountIntroText">

            <Typography.Title
              level={2}
              className="deleteAccountHi"
            >
              {t("lblHi")} {firstName}
            </Typography.Title>
{/* 
            <Typography.Text className="deleteAccountDescription">
              {t("lblDeleteAccountText")}
            </Typography.Text> */}

          </div>


          {/* Warning Card */}

          <section className="deleteWarningBox">

            {/* <div className="deleteWarningHeader">
              <div className="deleteWarningIcon">
                <DeleteOutlined />
              </div>

              <div>
                <Typography.Text className="deleteWarningTitle">
                  This will permanently delete
                </Typography.Text>

                <Typography.Text className="deleteWarningSubtitle">
                  Please review what will be removed from your account.
                </Typography.Text>
              </div>
            </div> */}


            <div className="deleteWarningItems">

              <div className="deleteWarningItem">
                <div className="deleteWarningItemIcon">
                  <DatabaseOutlined />
                </div>

                <div className="deleteWarningItemText">
                  <Typography.Text className="deleteWarningItemTitle">
                    {t("lblLinkedAccountsAndConsents")}
                  </Typography.Text>

                  <Typography.Text className="deleteWarningItemDescription">
                    {t("lblLinkedAccountsAndConsentsDescription")}
                  </Typography.Text>
                </div>
              </div>


              <div className="deleteWarningItem">
                <div className="deleteWarningItemIcon">
                  <ClockCircleOutlined />
                </div>

                <div className="deleteWarningItemText">
                  <Typography.Text className="deleteWarningItemTitle">
                    {t("lblAccountHistory")}
                  </Typography.Text>

                  <Typography.Text className="deleteWarningItemDescription">
                    {t("lblAccountHistoryDescription")}
                  </Typography.Text>
                </div>
              </div>


              <div className="deleteWarningItem">
                <div className="deleteWarningItemIcon">
                  <UserOutlined />
                </div>

                <div className="deleteWarningItemText">
                  <Typography.Text className="deleteWarningItemTitle">
                    {t("lblProfileInformation")}
                  </Typography.Text>

                  <Typography.Text className="deleteWarningItemDescription">
                    {t("lblProfileInformationDescription")}
                  </Typography.Text>
                </div>
              </div>
            </div>

          </section>


          {/* Confirmation */}

          <div className="deleteConfirmation">

            <Checkbox
              checked={understood}
              onChange={(event) =>
                setUnderstood(event.target.checked)
              }
            >
              <span className="deleteConfirmationText">
                {t("lblDeleteAccountText")}
              </span>
            </Checkbox>

          </div>


          {/* Actions */}

          <div className="deleteAccountActions">

            <Button
              className="deleteCancelButton"
              onClick={goBack}
            >
              {t("lblCancel")}
            </Button>

            <Button
              danger
              type="primary"
              disabled={!understood}
              className="accountDeleteButton"
              onClick={handleDeleteAccount}
              icon={<DeleteOutlined />}
            >
              {t(translation.lblDeleteAccount)}
            </Button>

          </div>

        </div>

      </div>


      {/* =================================================
          EXISTING OTP FLOW
      ================================================= */}

      <OTPInputComponent
        onCancel={closeModal}
        isOpen={isOTPModalVisible}
        onOtpSubmit={verifyDeleteAccount}
        okText={t("lblConfirm")}
        title={t("DeleteAccount")}
        onResend={handleDeleteAccount}
      />

    </CommonLayout>
  );
};


const mapStateToProps = (state: any) => ({
  user: state.user.user,
});


export default connect(mapStateToProps)(DeleteAccount);